import apiClient from './Api';
const PREFIX = '/youtubethumbnail';

const getAllThumbnails = postData =>
  apiClient({
    url: `${PREFIX}/getallthumbnails`,
    method: 'POST',
    data: postData
  });

const saveThumbnail = postData =>
  apiClient({
    url: `${PREFIX}/savethumbnail`,
    method: 'POST',
    data: postData
  });

const updateThumbnail = postData =>
  apiClient({
    url: `${PREFIX}/updatethumbnail`,
    method: 'POST',
    data: postData
  });

const deleteThumbnail = postData =>
  apiClient({
    url: `${PREFIX}/deletethumbnail`,
    method: 'POST',
    data: postData
  });

const youtubeThumbnailService = {
  getAllThumbnails,
  saveThumbnail,
  updateThumbnail,
  deleteThumbnail
};

export default youtubeThumbnailService;
